import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // Usa el detector de idioma
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    resources: {
      en: {
        translation: require('./locales/en/translation.json'),
      },
      es: {
        translation: require('./locales/es/translation.json'),
      },
    },
    interpolation: {
      escapeValue: false, // React ya maneja el escape de valores
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'], // Guardar el idioma en localStorage
      lookupLocalStorage: '_lang', // Clave en localStorage
      // 'checkWhitelist' ya no es válido aquí y se ha actualizado
    },
    supportedLngs: ['es', 'en'], // Idiomas permitidos
    // checkSupportedLngs: true, // Asegura que solo se usen idiomas soportados
  });

export default i18n;
